import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { ExclamationTriangleIcon } from "@radix-ui/react-icons";

interface FormErrorProps extends React.HTMLAttributes<HTMLDivElement> {
    errorMessage?: string;
}

/** DRF nests errors per field, and per nested serializer. Keep only the leaf messages. */
function flattenMessages(value: unknown): string[] {
    if (value === null || value === undefined) return [];
    if (Array.isArray(value)) return value.flatMap(flattenMessages);
    if (typeof value === "object") return Object.values(value).flatMap(flattenMessages);
    return [String(value)];
}

export function FormError({ errorMessage, ...props }: FormErrorProps) {
    if (errorMessage) {
        try {
            const messages = flattenMessages(JSON.parse(errorMessage));
            if (messages.length > 0) {
                return (
                    <Alert variant="destructive" {...props}>
                        <ExclamationTriangleIcon className="h-4 w-4" />
                        <AlertTitle>Une erreur est survenue</AlertTitle>
                        <AlertDescription>
                            <ul>
                                {messages.map((message, index) => (
                                    <li key={index}>{message}</li>
                                ))}
                            </ul>
                        </AlertDescription>
                    </Alert>
                );
            }
        } catch (e) {
            return (
                <Alert variant="destructive" {...props}>
                    <ExclamationTriangleIcon className="h-4 w-4" />
                    <AlertTitle>Une erreur est survenue</AlertTitle>
                    <AlertDescription>{errorMessage}</AlertDescription>
                </Alert>
            );
        }
    }
    return null;
}
